export default __webpack_public_path__ + "static/production6r-1e3d642cc3e05f4cd43ee3b29d64630f.jpg";